import {BTCWalletAdapter} from "../WalletAdapter";
import matchlog from "../../utils/matchlog";

export class UnisatAdapter implements BTCWalletAdapter {
    name = "Unisat Wallet";
    website="https://unisat.io/"
    walletKey="unisat"


    async isInstalled() {
        return typeof window.unisat !== "undefined";
    }

    async checkChain(){
        const chain =await window.unisat.getChain()

        if(chain.enum!="BITCOIN_MAINNET"){
            await window.unisat.switchChain("BITCOIN_MAINNET")
        }
    }

    async connect(): Promise<string> {
        if (!await this.isInstalled()) throw new Error("Unisat Wallet is not installed");
        window.unisat.disconnect()
        await this.checkChain()
        const accounts = await window.unisat.getAccounts();
        matchlog.log("accounts",accounts)
        if (accounts.length === 0) {
            const accounts = await window.unisat.requestAccounts();
            matchlog.log("accounts",accounts)
            if (!accounts || accounts.length === 0) throw new Error("No accounts found in Unisat Wallet");

            return accounts[0];
        }
        // await this.checkChain()
        return accounts[0];
    }

    async signMessage(message: string): Promise<string> {
        if (!await this.isInstalled()) throw new Error("Unisat Wallet is not installed");
        return window.unisat.signMessage(message,"bip322-simple");
    }

    async disconnet(): Promise<void> {
        if (!await this.isInstalled()) throw new Error("Unisat Wallet is not installed");
        return window.unisat.disconnect()
    }
}
